import { useAppSelector, useResponsive } from "@/hooks";
import { RootState } from "@/store/store";
import { selectedBranch } from "@/store/uiSlice";
import { Cancel01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Box, Drawer, IconButton, Paper, Stack, Typography } from "@mui/material";

interface OrderDrawerProps {
  isOpen: boolean;
  onClose?: () => void;
  anchor?: "left" | "right" | "top" | "bottom";
  variant?: "temporary" | "persistent" | "permanent";
  children?: React.ReactNode;
}

const OrderDrawer = ({ isOpen, onClose, anchor, variant, children }: OrderDrawerProps) => {
  const { isMobile } = useResponsive();
  const activeBranch = useAppSelector((state: RootState) => selectedBranch(state));

  return (
    <Drawer
      sx={{ border: 1, height: "100%" }}
      anchor={anchor ? anchor : isMobile ? "top" : "right"}
      open={isOpen}
      onClose={onClose}
      variant={variant}
      PaperProps={{
        sx: {
          borderBottomLeftRadius: isMobile ? "32px" : 0,
          borderBottomRightRadius: isMobile ? "32px" : 0,
          width: isMobile ? "100%" : "50%",
          height: "100%"
        },
      }}
    >
      <Box
        sx={{
          // border: '4px solid red',
          boxSizing: "border-box",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}>
        <Paper
          elevation={2}
          square
          sx={{
            zIndex: 10,
            paddingY: 1.5
          }}
        >
          <Stack
            direction={"row"}
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            px={3}
            py={1}
          >
            <Typography variant="h3">Cuenta{activeBranch ? ` - ${activeBranch?.title}` : ""}</Typography>
            <IconButton onClick={onClose}>
              <HugeiconsIcon icon={Cancel01Icon} />
            </IconButton>
          </Stack>
        </Paper>
        {children}
      </Box>
    </Drawer>
  );
};
export default OrderDrawer;
